// src/pages/UsloviKoristenja.js

import React from 'react';
import { Link } from 'react-router-dom';

const UsloviKoristenja = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '700px', margin: '0 auto' }}>
      <h1>Uslovi korištenja</h1>

      <p>
        Dobrodošli na <strong>kalkulator-plata.com</strong>. Korištenjem ovog sajta prihvatate sljedeće uslove.
        Ako se ne slažete s bilo kojim dijelom ovih uslova, molimo vas da ne koristite ovaj sajt.
      </p>

      <h2>1. Korištenje sajta</h2>
      <p>
        Ovaj sajt pruža alat za obračun plata, doprinosa i poreza u Republici Srpskoj i Bosni i Hercegovini.
        Sadržaj sajta je namjenjen isključivo informativne svrhe i ne predstavlja zvanični pravni ili poreski savet.
        Uvijek se konsultujte sa stručnjakom ako imate specifična pitanja o obračunu i zakonima.
      </p>

      <h2>2. Ograničenje odgovornosti</h2>
      <ul>
        <li>
          <strong>Bez garancija:</strong> Ovaj sajt se pruža „kao što jeste“ i „kako je dostupan“.
          Ne garantujem potpunu ispravnost rezultata obračuna niti neprekidan rad sajta.
        </li>
        <li>
          <strong>Ograničena odgovornost:</strong> Ja, Nebojša Pandžić, neću biti odgovoran
          za bilo kakvu direktnu ili indirektnu štetu nastalu korišćenjem sajta ili nemogućnošću korištenja istog.
        </li>
        <li>
          <strong>Zavisnost od trećih servisa:</strong> Ako koristim spoljne API-je (npr. za slanje mejlova), 
          ne snosim odgovornost za njihove greške ili prekide rada.
        </li>
      </ul>

      <h2>3. Linkovi ka drugim veb-sajtovima</h2>
      <p>
        Na ovom sajtu mogu se nalaziti linkovi ka trećim stranama (npr. članci, zakonski tekstovi, partnerski resursi).
        Ne kontrolišem sadržaj tih sajtova i ne snosim odgovornost za njihove prakse privatnosti ili pravilnost prikazanih informacija.
        Povezivanje ne znači podršku tim sajtovima.
      </p>

      <h2>4. Izmena sadržaja i uslova</h2>
      <p>
        Zadržavam pravo da u bilo kom trenutku izmenim, dopunim ili uklonim delove sajta, kao i da ažuriram ove
        Uslove korištenja bez prethodne najave. Ažurirane uslove ću objaviti na ovoj stranici s naznakom datuma poslednje revizije.
        Vaše dalje korištenje sajta nakon objave izmena smatra se prihvatanjem istih.
      </p>

      <h2>5. Pravo na prekid usluge</h2>
      <p>
        Zadržavam pravo da, bez prethodnog obaveštenja, privremeno ili trajno onemogućim pristup sajtu ili određenim
        funkcionalnostima ako se utvrdi da korisnik krši ove Uslove korištenja ili važeće zakone i propise.
      </p>

      <p>
        <em>Datum poslednje revizije: 05.06.2025.</em>
      </p>
    </div>
  );
};

export default UsloviKoristenja;
